export default __webpack_public_path__ + "static/media/img-bao-brokerage-account.5deb7b98.jpg";